import { useState } from "react";
import { Button } from "@mui/material";
import { Dropdown } from "@components/index";
import useOtaPartnerDownload from "../MisData/OtaPartner";
import useProbabilityMonitoringDownload from "../MisData/ProbabilityMonitoring";
import useRevenueDownload from "../MisData/Revenue";
import useTrainWisePerformanceDownload from "../MisData/TrainWisePerformance";
import useActiveJourneyDownload from "../MisData/ActiveJourney";
import { MIS_categories, useCreateMISDownloadLogic } from "./MISDownloadData";
import "./index.scss";
import useClaimRejectionDownload from "../MisData/ClaimRejection";

const MISDownload = ({ className = "", disabled = false, size = "medium" }) => {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);

  // Initialize all download hooks
  const otaPartnerHook = useOtaPartnerDownload();
  const probabilityMonitoringHook = useProbabilityMonitoringDownload();
  const revenueHook = useRevenueDownload();
  const trainPerformanceHook = useTrainWisePerformanceDownload();
  const activeJourneyHook = useActiveJourneyDownload();
  const activeClaimsRejectionHook = useClaimRejectionDownload();

  // Use the logic from MISDownloadData
  const { handleDownload } = useCreateMISDownloadLogic(
    selectedCategory,
    setIsDownloading,
    otaPartnerHook,
    probabilityMonitoringHook,
    revenueHook,
    trainPerformanceHook,
    activeJourneyHook,
    activeClaimsRejectionHook,
  );

  return (
    <div className={`mis-download ${className}`}>
      <div className="mis-download__container">
        <div className="mis-download__dropdown">
          <Dropdown
            label="Select Report Category"
            value={selectedCategory}
            onChange={setSelectedCategory}
            options={MIS_categories}
            placeholder="Choose a report type..."
            disabled={disabled || isDownloading}
            size={size}
            fullWidth
          />
        </div>

        <div className="mis-download__button">
          <Button
            variant="contained"
            onClick={handleDownload}
            disabled={disabled || !selectedCategory || isDownloading}
            size={size}
            className="mis-download__download-btn"
          >
            {isDownloading ? "Downloading..." : "Download Report"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MISDownload;
